import { render, staticRenderFns } from "./OverviewTwo.vue?vue&type=template&id=5755b851"
import script from "./OverviewTwo.vue?vue&type=script&lang=js"
export * from "./OverviewTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UtilHeadingAdvanced: require('/srv/app/components/util/HeadingAdvanced.vue').default,CardDefault: require('/srv/app/components/card/CardDefault.vue').default,ButtonLink: require('/srv/app/components/button/Link.vue').default})
